import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const leaveApi = axios.create({
  baseURL: `${API_BASE_URL}/leaves`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token
leaveApi.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
leaveApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const leaveService = {
  getAll: () => leaveApi.get(''),
  getByEmployeeId: (employeeId) => leaveApi.get(`/employee/${employeeId}`),
  getByStatus: (status) => leaveApi.get(`/status/${status}`),
  create: (leave) => leaveApi.post('', leave),
  getMyLeaves: () => leaveApi.get('/my'),
  createMyLeave: (leave) => leaveApi.post('/my', leave),
  approve: (leaveId, approvedBy) => leaveApi.put(`/${leaveId}/approve`, null, {
    params: { approvedBy }
  }),
  reject: (leaveId, rejectionReason) => leaveApi.put(`/${leaveId}/reject`, null, {
    params: { rejectionReason }
  }),
  delete: (leaveId) => leaveApi.delete(`/${leaveId}`),
  getBalance: (employeeId) => leaveApi.get(`/balance/${employeeId}`),
  getCalendar: (params) => leaveApi.get('/calendar', { params }),
  approveByManager: (leaveId, approvedBy) => leaveApi.put(`/${leaveId}/approve-manager`, null, {
    params: { approvedBy }
  }),
  rejectByManager: (leaveId, rejectionReason) => leaveApi.put(`/${leaveId}/reject-manager`, null, {
    params: { rejectionReason }
  }),
  approveByRH: (leaveId, approvedBy) => leaveApi.put(`/${leaveId}/approve-rh`, null, {
    params: { approvedBy }
  }),
  rejectByRH: (leaveId, rejectionReason) => leaveApi.put(`/${leaveId}/reject-rh`, null, {
    params: { rejectionReason }
  }),
  getAvailableAnnualDays: (employeeId) => leaveApi.get(`/available-annual-days/${employeeId}`),
  updateLeaveBalance: (employeeId, adjustment, reason) => {
    const employeeApi = axios.create({
      baseURL: `${API_BASE_URL}/employees`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
    return employeeApi.put(`/${employeeId}/leave-balance`, {
      adjustment,
      reason,
    });
  },
  generateAnnualReport: (year, format = 'pdf') => {
    return leaveApi.get('/report/annual', {
      params: { year, format },
      responseType: 'blob',
    });
  },
  generatePeriodReport: (startDate, endDate, format = 'pdf') => {
    return leaveApi.get('/report/period', {
      params: { startDate, endDate, format },
      responseType: 'blob',
    });
  },
};

export default leaveService;

